import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Breadcrumbs,
  Grid,
  Typography,
  Button,
  SvgIcon
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { makeStyles } from '@mui/styles';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  PlusCircle as PlusCircleIcon,
} from 'react-feather';

const useStyles = makeStyles(() => ({
  root: {}
}));

function Header({ className, ...rest }) {
  const classes = useStyles();
  const userType = useSelector(
    (state) => state?.account?.user?.userType
  );
  const isDisabled = userType === 'ADMIN' || userType === 'SUPPORT';
  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      justify="space-between"
      spacing={3}
      {...rest}
    >
      <Grid item>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Typography
            variant="h3"
            color="textPrimary"
          >
           Admin View
          </Typography>
        </Breadcrumbs>
        </Grid>        
        <Grid item>
        <Button
        disabled={isDisabled}
        variant='contained'
        color="secondary"
          component={RouterLink}
          to="/app/management/add/admin"
        >
          <SvgIcon
            fontSize="small"
            className={classes.actionIcon}
          >
            <PlusCircleIcon />
          </SvgIcon>
          Add Admin
        </Button>
      </Grid>      
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
